import { render } from "./ContextMenu.vue?vue&type=template&id=bd5371b0&scoped=true&ts=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=bd5371b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5371b0"]])

export default __exports__